<template>
  <v-card tile>
    <v-toolbar card dark color="teal lighten-2">
      <v-toolbar-title>Código: {{ mcodigo }}</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-toolbar-items>
        <v-btn dark flat @click="$emit('close')">Cerrar</v-btn>
      </v-toolbar-items>
    </v-toolbar>
    <v-card-text>
      <v-progress-linear v-if="mloading" :indeterminate="true"></v-progress-linear>
      <v-container grid-list-lg fluid class="pa-0">
        <v-layout row wrap>
          <v-flex xs12 sm8>
            <v-card>
              <v-card-text>
                <h4 class="grey--text text--darken-2">Datos del Centro de Capacitación</h4>
              </v-card-text>
              <v-divider></v-divider>
              <v-card-text>
                <v-list subheader class="py-0">
                  <v-list-tile>
                    <v-list-tile-content>
                      <v-list-tile-title>Nombre del CCTP</v-list-tile-title>
                      <v-list-tile-sub-title>{{ mcentro.institucioneducativa }}</v-list-tile-sub-title>
                    </v-list-tile-content>
                  </v-list-tile>
                  <v-list-tile>
                    <v-list-tile-content>
                      <v-list-tile-title>Sigla</v-list-tile-title>
                      <v-list-tile-sub-title>{{ minfor.sigla }}</v-list-tile-sub-title>
                    </v-list-tile-content>
                  </v-list-tile>
                  <v-list-tile>
                    <v-list-tile-content>
                      <v-list-tile-title>Dirección</v-list-tile-title>
                      <v-list-tile-sub-title>{{ mcentro.jurisdiccion_geografica.direccion }}</v-list-tile-sub-title>
                    </v-list-tile-content>
                  </v-list-tile>
                  <v-list-tile>
                    <v-list-tile-content>
                      <v-list-tile-title>Zona</v-list-tile-title>
                      <v-list-tile-sub-title>{{ mcentro.jurisdiccion_geografica.zona }}</v-list-tile-sub-title>
                    </v-list-tile-content>
                  </v-list-tile>
                </v-list>
              </v-card-text>
            </v-card><br>
            <v-card>
              <v-card-text>
                <h4 class="grey--text text--darken-2">Cursos de Capacitación</h4>
              </v-card-text>
              <v-divider></v-divider>
              <v-data-table
                :headers="headersCurso"
                :items="mcursos"
                class="elevation-1"
                no-data-text="Sin registros"
                hide-actions
              >
                <template v-slot:items="props">
                  <td>{{ props.index + 1 }}</td>
                  <td>{{ props.item.codigo }}</td>
                  <td>{{ props.item.curso }}</td>
                  <td>{{ props.item.carga_horaria }}</td>
                  <td>{{ props.item.tiempo_estudio }}</td>
                </template>
              </v-data-table>
            </v-card>
          </v-flex>
          <v-flex xs12 sm4>
            <v-card>
              <v-card-title>
                <h4 class="grey--text text--darken-2">Localización</h4>
              </v-card-title>
              <v-divider></v-divider>
              <v-card-text>
                <p><b>Coordenada:</b> [{{mcentro.jurisdiccion_geografica.cordx}}, {{mcentro.jurisdiccion_geografica.cordy}}]</p>
                <div id="lmap" style="width: 100%; height: 70vh"></div>
              </v-card-text>
            </v-card>
          </v-flex>
        </v-layout>
      </v-container>
    </v-card-text>
    <div style="flex: 1 1 auto;"></div>
  </v-card>
</template>
<script>
export default {
  name: "detalle-centro",
  props: ['mcentro', 'mcursos', 'mcodigo', 'mloading', 'minfor'],
  data: () => ({
    headersCurso: [
      { text: 'Nro', align: 'left', sortable: false },
      { text: 'Código ', sortable: false },
      { text: 'Curso de Capacitación ', sortable: false },
      { text: 'Carga Horaria ', sortable: false },
      { text: 'Tiempo (1 mes) ', sortable: false }
    ],
  }),
};
</script>